export default __webpack_public_path__ + "static/media/kieran.4a1af47b.jpg";